import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import MagazineArticleTemplate from '../components/MagazineArticleTemplate';
import { getArticle } from '../data/magazine';
import { findShortRouteBySlug } from '../data/seoShortRoutes';

/**
 * Route dynamique /magazine/:slug.
 * Récupère l'article depuis le registre et l'affiche via le template générique.
 *
 * Si l'article a un slug court SEO associé (ex. /casque-moto-ece-22-06), on
 * passe `pathOverride` pour que la balise canonical pointe vers la version
 * courte. Cela évite le duplicate content et consolide l'autorité SEO sur
 * l'URL keyword-rich.
 *
 * Si le slug est inconnu → redirection vers la page sommaire /magazine.
 */
export default function MagazineArticlePage() {
  const { slug } = useParams();
  const article = getArticle(slug);

  if (!article) {
    return <Navigate to="/magazine" replace />;
  }

  // Si une route SEO courte existe pour ce slug → forcer le canonical dessus
  const shortRoute = findShortRouteBySlug(slug);

  return (
    <MagazineArticleTemplate
      article={article}
      pathOverride={shortRoute?.path}
    />
  );
}
